module.exports = __webpack_public_path__ + "static/1 (3)-e1b94bec5bbe1cf4f5cbb87b897b0df1.jpg";